export default __webpack_public_path__ + "static/Pond_Skimmer_Repair_Andreatta_Waterscapes_Ashland_Oregon_compress-fd37a49be0438c513c605e5ace1ec87d.jpg";